/**
 * Legacy module shell — kept so AngularJS modules that declare
 * 'acme.common.service.contact' as a dependency keep bootstrapping.
 *
 * The real implementation lives at:
 *   apps/b2b-frontend/app/core/contact/contact.service.ts
 *
 * Registered with AngularJS via downgradeInjectable in
 *   apps/b2b-frontend/app/upgrade/ng-downgraded-components.ts
 * so any $inject = ['ContactService'] resolves to the Angular 18 class.
 *
 * Do NOT register `.service('ContactService', ...)` here — it would shadow
 * the downgraded Angular 18 service. The 'acme.common.service.validate' dep
 * is preserved for module-graph parity (the legacy service declared it).
 */
angular.module('acme.common.service.contact', ['acme.common.service.validate']);
